import { Modal } from "App/Component/ui";
import React from "react";
import { ListTemplate } from "../../Template/Template";

function ModalTemplate({ setShowModal, handleClickSelect }) {
  return (
    <Modal title='Daftar Template' width={"70%"} show={setShowModal}>
      <ListTemplate
        handleClickSelect={handleClickSelect}
        onlySelect={true}
        withForm={false}
      />
    </Modal>
  );
}

export default ModalTemplate;
